// src/components/CTABanner.jsx
import React from 'react';
import { Link } from 'react-scroll';

const CTABanner = () => {
  return (
    <section style={styles.section} data-aos="zoom-in">
      {/* Decorative leaves/circles */}
      <div style={styles.decor1} aria-hidden="true" />
      <div style={styles.decor2} aria-hidden="true" />
      <div style={styles.decor3} aria-hidden="true" />

      <div style={styles.container}>
        <span style={styles.badge}>Take the First Step</span>
        <h2 style={styles.heading}>Ready to Begin Your Journey?</h2>
        <p style={styles.subtext}>
          Take the first step toward a healthier, happier you. We are here to help —
          compassionate, confidential, and professional care awaits.
        </p>
        <div style={styles.btnRow}>
          <Link
            to="contact"
            smooth={true}
            duration={600}
            offset={-80}
            style={styles.ctaBtn}
          >
            Book Your Session Now
          </Link>
          {/* <a href="tel:+919420085453" style={styles.phoneBtn}> */}
          <a href="tel:+919004910709" style={styles.phoneBtn}>

            📞 Call Us Today
          </a>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: '#1B3F6E',
    padding: '80px 24px',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  decor1: {
    position: 'absolute',
    top: -60,
    left: -60,
    width: 280,
    height: 280,
    borderRadius: '50%',
    border: '40px solid rgba(90,158,75,0.15)',
    pointerEvents: 'none',
  },
  decor2: {
    position: 'absolute',
    bottom: -80,
    right: -40,
    width: 320,
    height: 320,
    borderRadius: '50%',
    border: '50px solid rgba(214,232,247,0.08)',
    pointerEvents: 'none',
  },
  decor3: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    height: 600,
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(90,158,75,0.06) 0%, transparent 70%)',
    pointerEvents: 'none',
  },
  container: {
    maxWidth: 720,
    margin: '0 auto',
    position: 'relative',
    zIndex: 1,
  },
  badge: {
    display: 'inline-block',
    backgroundColor: 'rgba(90,158,75,0.25)',
    color: '#5A9E4B',
    border: '1px solid rgba(90,158,75,0.4)',
    borderRadius: 50,
    padding: '5px 18px',
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 2,
    textTransform: 'uppercase',
    fontFamily: "'Lato', sans-serif",
    marginBottom: 20,
  },
  heading: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 'clamp(28px, 4vw, 44px)',
    fontWeight: 700,
    color: '#ffffff',
    lineHeight: 1.2,
    marginBottom: 20,
  },
  subtext: {
    fontSize: 17,
    color: '#B8D4F0',
    lineHeight: 1.8,
    marginBottom: 40,
    maxWidth: 560,
    margin: '0 auto 40px',
  },
  btnRow: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: 16,
  },
  ctaBtn: {
    backgroundColor: '#ffffff',
    color: '#1B3F6E',
    border: '2px solid #ffffff',
    borderRadius: 50,
    padding: '14px 36px',
    fontFamily: "'Lato', sans-serif",
    fontWeight: 700,
    fontSize: 15,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    display: 'inline-block',
  },
  phoneBtn: {
    backgroundColor: 'transparent',
    color: '#ffffff',
    border: '2px solid rgba(255,255,255,0.4)',
    borderRadius: 50,
    padding: '14px 36px',
    fontFamily: "'Lato', sans-serif",
    fontWeight: 700,
    fontSize: 15,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    display: 'inline-block',
  },
};

export default CTABanner;
